<template>
  <div v-if="hc.id" class="pb-4">
    <a class="card shadow-sm-card cursor-pointer text-decoration-none text-dark" :href="'/hc/' + hc.id">
      <div class="ratio ratio-16x9">
        <img v-if="hc.images.length > 0" :src="'data:image;base64,' + hc.images[0].image"
             class="card-img-top object-fit-cover" alt="HousingComplex">
      </div>
      <div class="card-body">
        <h5 v-if="hc.name" class="card-title text-truncate">ЖК «{{ hc.name }}»</h5>
        <p v-if="hc.description" class="card-text text-hc-card">{{ hc.description }}</p>
      </div>
    </a>
  </div>
</template>

<script>
export default {
  name: "home-hc-card",
  props: {
    hc: {
      type: Object,
      default: {}
    }
  }
}
</script>

<style scoped>
.shadow-sm-card {
  transition: all .3s;
}

.shadow-sm-card:hover {
  box-shadow: 0 .25rem .5rem rgba(0, 0, 0, .125) !important
}

.text-hc-card {
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 5;
  -webkit-box-orient: vertical;
}

@media (min-width: 576px) {
  .card-body {
    min-height: 184px
  }
}

</style>